import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cm from 'helpers/commons';
import { Item } from 'semantic-ui-react';
import { BillApprovals } from 'components/Bill';

const propTypes = {
  detail: PropTypes.object,
  approval: PropTypes.array,
  salesSum: PropTypes.number,
  companySum: PropTypes.number
};

const defaultProps = {
  detail: null,
  approval: [],
  salesSum: null,
  companySum: null
};

class BillInfo extends Component {
  render() {
    const {
      detail,
      approval,
      salesSum,
      companySum,
      billRejected,
      billParentRejected,
      billAccepted,
      modalFn,
      onOpenModal,
      items
    } = this.props;
    const { invoiced, created, start, end } = detail.date;
    const ticketFormat = cm.unit();
    const invoiceYmd = cm.yyyyMMdd(invoiced);
    const createYmd = cm.yyyyMMdd(created);
    const createHms = cm.hhmmss(new Date(created));
    const startDate = cm.yyyyMMdd(start);
    const endDate = cm.yyyyMMdd(end);
    let approvalStatus = '';
    let invoiceStatus = '';
    let invoiceRange = null;
    let rejectNote = '';
    let approvalMessage = '';
    let approvalTime = '';
    const { parentApproval, range } = detail;
    const rangeType = range ? range.type : null;
    if (approval && approval.length > 0) {
      approval.map((item) => {
        const { users } = item;
        users.map((user) => {
          switch (user.status) {
            case 'PROCESSING':
              if (invoiceStatus === '') {
                invoiceStatus = `${user.userInfo.name} 진행중`;
              }
              break;

            case 'ACCEPTED':
              invoiceStatus = '결재 완료';
              break;

            case 'REJECTED':
              invoiceStatus = <div style={{ color: 'red' }}>{user.userInfo.name} 반려</div>;
              rejectNote = user.notes;
              break;

            default:
              '';
          }
        });
      });
    }

    if (detail) {
      const { type, value } = detail.range || {};

      switch (type) {
        case 'DIVISION':
          invoiceRange = Array.isArray(value) ? value.join(', ') : '-';
          break;

        case 'OFFICE':
          invoiceRange = Array.isArray(value) && value.length > 0 ? value[0] : '-';
          break;

        default:
          // 범위 미확정 청구서(range.value === null)에서 null.join 크래시 방지
          invoiceRange = Array.isArray(value) ? value.join(' + ') : '-';
      }

      if (detail.approvalStatus === 'PENDING') {
        approvalStatus = '청구 계좌 결재 진행중';
      } else if (detail.approvalStatus === 'PROCESSING') {
        approvalStatus = invoiceStatus;
      } else if (detail.approvalStatus === 'ACCEPTED') {
        approvalStatus = '결재 완료';
      } else if (detail.approvalStatus === 'REJECTED') {
        approvalStatus = invoiceStatus;
      }
    }
    if (parentApproval && parentApproval.approvalMessage) {
      approvalMessage = <div style={{ color: 'red' }}>{detail.parentApproval.approvalMessage}</div>;
      const yyyyMMddhhmmssTime = `${cm.yyyyMMdd(parentApproval.approvalTime)} ${cm.hhmmss(
        new Date(parentApproval.approvalTime)
      )}`;
      approvalTime = <div style={{ color: 'red' }}>{`${yyyyMMddhhmmssTime} 반려`}</div>;
    }

    const modalIf = {
      start: startDate,
      end: endDate,
      range: invoiceRange,
      format: ticketFormat,
      salesSum,
      companySum,
      parentApproval: detail.parentApproval
    };

    return (
      <StyledContent>
        <h4>
          <StyledInlineText>{detail.billingAccountName}</StyledInlineText>
          <StyledInlineText>
            {invoiceYmd.substring(5, 7)}월 {invoiceYmd.substring(8, 10)}일
          </StyledInlineText>
          청구서
        </h4>
        <StyledItemGroup>
          <Item>
            <StyledItemHeader>청구 기간</StyledItemHeader>
            <Item.Content>
              {startDate} 부터 {endDate} 까지
            </Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>발행 날짜</StyledItemHeader>
            <Item.Content>
              {createYmd} {createHms}
            </Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>청구 범위</StyledItemHeader>
            <Item.Content>{invoiceRange}</Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>청구 번호</StyledItemHeader>
            <Item.Content>{detail.invoiceIdx}</Item.Content>
          </Item>
          <Item>
            <StyledItemHeader>결재 현황</StyledItemHeader>
            <Item.Content>
              {/* eslint-disable-next-line no-nested-ternary */}
              {approvalMessage !== '' ? approvalMessage : rangeType === 'PARENT' ? approvalStatus : invoiceStatus}
            </Item.Content>
          </Item>
          {approvalMessage !== '' ? (
            <Item>
              <StyledItemHeader>반려시간</StyledItemHeader>
              <Item.Content>{approvalTime}</Item.Content>
            </Item>
          ) : (
            ''
          )}
          {items ? (
            <Item>
              <StyledItemHeader>회사식대 총액</StyledItemHeader>
              <Item.Content>
                {cm.numberComma(salesSum)}
                {ticketFormat}
                {ticketFormat === '장' ? `(${cm.numberComma(companySum)}원)` : null}
              </Item.Content>
            </Item>
          ) : null}
          {detail.approvalStatus === 'REJECTED' ? (
            <Item>
              <StyledItemHeader>반려 사유</StyledItemHeader>
              <Item.Content>{rejectNote}</Item.Content>
            </Item>
          ) : null}
        </StyledItemGroup>
        <BillApprovals
          detail={detail}
          approval={approval}
          onOpenModal={onOpenModal}
          modalFn={modalFn && modalFn.btnName !== 'REJECT LIST BUTTON' ? modalFn : null}
          modalIf={modalIf}
          iIdx={detail.invoiceIdx}
          billRejected={billRejected}
          billParentRejected={billParentRejected}
          billAccepted={billAccepted}
        />
      </StyledContent>
    );
  }
}

const StyledContent = styled.section`
  position: relative;
  margin-bottom: 24px;
`;

const StyledItemGroup = styled(Item.Group)`
  font-weight: bold;
`;

const StyledItemHeader = styled(Item.Header)`
  min-width: 150px;
  width: 150px;
  font-size: 14px;
`;

const StyledInlineText = styled.span`
  margin: 0 5px;
  &:first-child {
    margin-left: 0;
  }
`;

BillInfo.propTypes = propTypes;
BillInfo.defaultProps = defaultProps;

export default BillInfo;
